import React from 'react';
import { Col} from "react-bootstrap"
import "./SecondRow.css"

import { useGlobalState } from '../../../config/routes';

const LeftLowerPanel = () => {

    const {isBusinessVisible} = useGlobalState();



    return (
        // ADD VIEW COUNT
            <Col className={(isBusinessVisible ? " " : "") +'col-12 col-sm-4 forthThird_container mb-3'} id="whoami">
                <h1>My story</h1>
                <p>I know how it feels to be at a crossroads, unsure where to begin. As a former <b>Mechatronics Engineer</b>, now completing my <b>CS degree</b> in Canada, I quickly realized a traditional job wouldn't be enough. The path to true <b>success</b>, especially as an international student, lay in <b>entrepreneurship</b>, <b>side income</b>, and personal projects. I <b>craved a clear direction</b>, a proven system, and crucial <b>mentorship</b>.

                My journey led me to the right mentors and a <b>thriving business</b>. I've built valuable <b>partnerships</b>, committed to <b>self-development</b>, and gained a clearer vision, all while surrounding myself with <b>ambitious individuals</b>. Today, I'm successfully growing my business <b>across North America</b>, serving a robust customer base, and providing health/wellness/fitness consultations, all while continuing my <b>professional growth</b> as a Developer.</p>

            </Col>

    );
};

export default LeftLowerPanel;
